import React, { useMemo, useState } from 'react';
import StoryGalleryCard from '../components/StoryGalleryCard';
import styles from '../styles/Design_Lab.module.css';
import { projects } from '../feature_projects/projects.js';

const filterButtons = [
    { label: 'web series', value: 'web series' },
    { label: 'podcasts', value: 'podcasts' },
    { label: 'documentary', value: 'documentary' },
];

const StoryGallery = () => {
    const [activeCategory, setActiveCategory] = useState('all');

    const filteredProjects = useMemo(() => {
        if (activeCategory === 'all') return projects;

        return projects.filter((project) => {
            const genre = String(project.genre || '').toLowerCase();

            const tags = Array.isArray(project.tags)
                ? project.tags.map((tag) => String(tag).toLowerCase())
                : [];

            if (activeCategory === 'web series') {
                return genre.includes('web series') || tags.includes('web series');
            }

            if (activeCategory === 'podcasts') {
                return genre.includes('podcast') || tags.includes('podcast');
            }

            if (activeCategory === 'documentary') {
                return genre.includes('documentary') || tags.includes('documentary');
            }

            return true;
        });
    }, [activeCategory]);

    return (
        <div className={styles.pageShell}>
            <div className={styles.pageContainer}>
                <div className={styles.pageLayout}>
                    <aside className={styles.indexRail} aria-hidden="true">
                        <span className={styles.indexRailLabel}>
                            Story Lab
                        </span>
                    </aside>

                    <main className={styles.mainContent}>
                        <header className={styles.magazineHeader}>
                            <div className={styles.magazineHeaderTop}>
                                <span className={styles.magazineKicker}>
                                    Meshae Studios
                                </span>

                                <span className={styles.magazineIssue}>
                                    Production Portfolio
                                </span>
                            </div>

                            <h1 className={styles.magazineTitle}>Story Lab</h1>
                        </header>

                        <section
                            className={styles.categorySection}
                            aria-label="Story categories"
                        >
                            <span className={styles.categoryLabel}>
                                Categories
                            </span>

                            <div className={styles.categoryBar}>
                                <button
                                    type="button"
                                    className={`${styles.categoryButton} ${activeCategory === 'all'
                                        ? styles.categoryButtonActive
                                        : ''
                                        }`}
                                    onClick={() => setActiveCategory('all')}
                                >
                                    all
                                </button>

                                {filterButtons.map((item) => (
                                    <button
                                        key={item.value}
                                        type="button"
                                        className={`${styles.categoryButton} ${activeCategory === item.value
                                            ? styles.categoryButtonActive
                                            : ''
                                            }`}
                                        onClick={() =>
                                            setActiveCategory(item.value)
                                        }
                                    >
                                        {item.label}
                                    </button>
                                ))}
                            </div>
                        </section>

                        <section
                            className={styles.projectListSection}
                            id="story-projects"
                            aria-label="Story Lab projects"
                        >
                            <div className={styles.projectList}>
                                {filteredProjects.map((project, index) => (
                                    <StoryGalleryCard
                                        key={project.slug}
                                        project={project}
                                        index={index}
                                        total={filteredProjects.length}
                                    />
                                ))}
                            </div>
                        </section>
                    </main>
                </div>
            </div>
        </div>
    );
};

export default StoryGallery;